import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import { Provider } from 'react-redux';
import step from './reducers';
import thunk from 'redux-thunk';
import * as API from './api';
import $ from 'jquery';
import { getIsDirty } from './reducers/dirty';
import { withCurrentReferer } from 'plugins/contextual-back';
import { displayConfirmModalIfNeeded } from './confirm-validation';
import { hideLoader } from 'plugins/loader';
import { success, error } from 'plugins/toastr';
import { bindModal } from '../common/modals/index';
import { renderList } from 'utils/async-list';
import { withReferer } from 'plugins/contextual-back';
import { Column } from 'react-virtualized';
import moment from 'moment';

export function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('intervention-frame');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');
  const caseId = root.getAttribute('data-case-id');

  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#intervention-frame form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  ReactDOM.render(
    <Provider store={store}>
      <Page
        id={parseInt(id, 10)}
        customerId={parseInt(customerId, 10)}
        caseId={parseInt(caseId, 10)}
      />
    </Provider>,
    root
  );

  const update = id => {
    const form = store.getState().form;

    API.update(id, form).then(
      response => {
        success('Intervention enregistrées avec succès');
        window.location.replace(withCurrentReferer(response.url));
      },
      err => {
        console.debug(err);
        if (err.res.status === 409) {
          err.res.text().then(message => error(message));
        } else {
          error('Une erreur est survenue pendant la sauvegarde ');
        }
      }
    );
  };

  bindModal();

  const cleanDirty = () => $('#intervention-frame form').removeClass('dirty');

  $('#bt-validate-intervention').on('click', function(evt) {
    evt.preventDefault();
    const idsArray = Array.of($(evt.target).data('id'));
    if (idsArray && idsArray.length) {
      // Serialize ids as JSON and execute given URL
      const $button = $(evt.currentTarget);
      const action = $button.attr('data-action');
      const method = $button.attr('data-method');
      const id = $button.attr('data-id');

      displayConfirmModalIfNeeded(false, () => {
        $button.addClass('loading');
        const form = store.getState().form;

        API.update(id, form)
          .then(res => {
            return fetch(action, {
              method: method,
            }).then(inter => {
              if (inter.status >= 400) return inter;
              else return res;
            });
          })
          .then(res => {
            if (res.status >= 400) {
              console.log('Error attempting to validate intervention', res);

              const errorHeader = res.headers.get('errorCustom');
              let errorLabel;

              if (errorHeader) {
                errorLabel = errorHeader;
              } else {
                errorLabel =
                  "Une erreur est survenue pendant la validation de l'intervention";
              }

              hideLoader();
              $button.removeClass('loading');
              error(errorLabel);
            } else
              window.location.replace(withCurrentReferer(res.url), err => {
                console.log('Error attempting to save intervention', err);

                const errorHeader = err.res.headers.get('errorCustom');
                let errorLabel;

                if (errorHeader) {
                  errorLabel = errorHeader;
                } else {
                  errorLabel =
                    "Une erreur est survenue pendant la sauvegarde de l'intervention";
                }

                hideLoader();
                error(errorLabel);
              });
          });
      });
    }
  });

  const saveButton = document.getElementById('bt-save');
  if (saveButton) {
    const id = saveButton.getAttribute('data-id');
    saveButton.onclick = () => {
      cleanDirty();
      update(id);
    };
  }
}

export function byAastCase(ctx) {
  const caseId = ctx.params.id;

  renderAast(
    `/pco-manager/aast/cases/${caseId}/interventions.json`,
    `/pco-manager/aast/cases/${caseId}/interventions`
  );
  bindModal();
}

export function byAastCustomer(ctx) {
  const customerId = ctx.params.id;

  renderAast(
    `/pco-manager/aast/customers/${customerId}/interventions.json`,
    `/pco-manager/aast/customers/${customerId}/interventions`
  );
}

export function byAastSite(ctx) {
  const siteId = ctx.params.id;

  renderAast(
    `/pco-manager/aast/sites/${siteId}/interventions.json`,
    `/pco-manager/aast/sites/${siteId}/interventions`
  );
}

function renderAast(url, from) {
  const rowClickedUrl = id =>
    withReferer(`/pco-manager/aast/cases/interventions/${id}`, from);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderAastColumns);
}

function renderAastColumns(width) {
  return [
    <Column
      key="date"
      dataKey="date"
      cellRenderer={renderDate}
      width={width / 16 * 4}
      label="Date"
    />,
    <Column
      key="worker_name"
      dataKey="worker_name"
      headerClassName="right aligned"
      width={width / 16 * 10}
      label="Technicien principal"
    />,
    <Column
      key="status"
      dataKey="status"
      cellRenderer={renderStatus}
      width={width / 16 * 2}
      label="Statut"
    />,
  ];
}

const renderPreplanningDate = preplanningDate => {
  const date = moment(preplanningDate).weekday(0);
  const week = date.isoWeek();
  const year = date.get('year');

  var label = `Semaine ${week} (${year})`;

  if (
    Number.isNaN(week) ||
    week == undefined ||
    Number.isNaN(year) ||
    year == undefined
  ) {
    label = '';
  }

  return label;
};

const renderSimpleDate = rowDate => {
  return moment(rowDate).format('DD/MM/YYYY');
};

function renderDate({ rowData }) {
  let label;

  switch (rowData.status) {
    case 'TO_PLAN':
      label = '';
      break;
    case 'PREPLANNED':
      label = renderPreplanningDate(rowData.date);
      break;
    case 'PLANNED':
      label = renderSimpleDate(rowData.date);
      break;
    case 'RUNNING':
      label = renderSimpleDate(rowData.date);
      break;
    case 'WAITING_SYNC':
      label = renderSimpleDate(rowData.date);
      break;
    case 'NOT_EXECUTED':
      label = renderSimpleDate(rowData.date);
      break;
    case 'NOT_EXECUTED_JUSTIF':
      label = renderSimpleDate(rowData.date);
      break;
    case 'CANCELED':
      if (rowData.date) {
        label = renderSimpleDate(rowData.date);
      } else if (rowData.date) {
        label = renderPreplanningDate(rowData.date);
      } else {
        label = '';
      }

      break;
    case 'EXECUTED':
      label = renderSimpleDate(rowData.date);
      break;
    case 'VALIDATED':
      label = renderSimpleDate(rowData.date);
      break;
    default:
      break;
  }

  return label;
}

function renderStatus({ rowData, style, key }) {
  let label, title, opt;

  switch (rowData.status) {
    case 'TO_PLAN':
      label = 'ui orange label';
      title = 'A planifier';
      break;
    case 'PREPLANNED':
      label = 'ui orange label';
      title = 'Pré-planifiée';
      break;
    case 'PLANNED':
      label = 'ui green label';
      title = 'Planifiée';
      break;
    case 'EXECUTED':
      label = 'ui green label';
      title = 'Exécutée';
      break;
    case 'WAITING_SYNC':
      label = 'ui red label';
      title = 'En attente de rapport';
      break;
    case 'NOT_EXECUTED':
      label = 'ui red label';
      title = 'Non saisie';
      break;
    case 'NOT_EXECUTED_JUSTIF':
      label = 'ui red label';
      title = 'Non réalisée';
      opt = rowData.justif;
      break;
    case 'CANCELED':
      label = 'ui grey label';
      title = 'Annulée';
      break;
    case 'VALIDATED':
      label = 'ui grey label';
      title = 'Validée';
      break;
    default:
      break;
  }

  if (label && title) {
    if (opt) {
      return (
        <span
          key={key}
          className={label}
          data-tooltip={opt}
          style={style}
          data-position="left center"
        >
          {title}
        </span>
      );
    } else {
      return <span className={label}>{title}</span>;
    }
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/index.js